import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Header from "../../components/header";
import heroImage from "../../images/sme-banner.png";

const geist = { fontFamily: "'Geist', sans-serif" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const OPEN_ACCOUNT_URL = "https://zikoramfb.qoreonline.com/onboarding/type";

const SmeMain = () => {
  return (
    <>
      <style>{`
        .sme-hero-row {
          max-width: 1280px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          gap: clamp(32px, 4.17vw, 72px);
        }
        .sme-hero-text { flex: 1 1 0; min-width: 0; }
        .sme-hero-image-wrap { flex: 1 1 0; min-width: 0; }
        .sme-hero-buttons a { white-space: nowrap; }
        @media (max-width: 900px) {
          .sme-hero-row { flex-direction: column !important; align-items: stretch !important; }
          .sme-hero-image-wrap { width: 100% !important; }
        }
        @media (max-width: 380px) {
          .sme-hero-buttons a { padding: 0 16px !important; font-size: 13px !important; }
        }
      `}</style>

      <Header />

      <section
        style={{
          marginTop: "-88px",
          width: "100%",
          backgroundColor: "#132A22",
          boxSizing: "border-box",
          padding:
            "clamp(120px, 11.11vw, 172px) clamp(20px, 5.56vw, 80px) clamp(56px, 6.94vw, 100px)",
        }}
      >
        <div className="sme-hero-row">
          {/* Left: text + CTAs */}
          <div
            className="sme-hero-text"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "clamp(20px, 1.94vw, 28px)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#86C7A8",
                  flexShrink: 0,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  ...geistMono,
                  fontWeight: 500,
                  fontSize: "12px",
                  lineHeight: 1,
                  letterSpacing: "0.1em",
                  color: "#86C7A8",
                  textTransform: "uppercase",
                }}
              >
                SME Banking &middot; Eastern Nigeria
              </span>
            </div>

            <h1
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(32px, 6.5vw, 80px)",
                lineHeight: 1.06,
                letterSpacing: "-0.015em",
                color: "#FFFFFF",
                margin: 0,
                overflowWrap: "break-word",
              }}
            >
              Banking built for{" "}
              <span
                style={{
                  ...instrumentSerif,
                  fontStyle: "italic",
                  color: "#86C7A8",
                }}
              >
                growing
              </span>{" "}
              businesses in Eastern Nigeria.
            </h1>

            <p
              style={{
                ...geist,
                fontWeight: 400,
                fontSize: "clamp(14px, 1.25vw, 18px)",
                lineHeight: 1.7,
                color: "#C9D6CE",
                margin: 0,
                maxWidth: "480px",
              }}
            >
              From daily operations to expansion plans, Zikora gives SMEs the
              financial support, tools, and flexibility to move faster and grow
              with confidence.
            </p>

            <div
              className="sme-hero-buttons"
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                marginTop: "8px",
              }}
            >
              <a
                href={OPEN_ACCOUNT_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...geist,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "52px",
                  padding: "0 24px",
                  backgroundColor: "#86C7A8",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "clamp(13px, 1.11vw, 16px)",
                  color: "#132A22",
                  textDecoration: "none",
                }}
              >
                Open Account
              </a>
              <RouterLink
                to="/contact"
                style={{
                  ...geist,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "52px",
                  padding: "0 24px",
                  backgroundColor: "transparent",
                  border: "1px solid rgba(222, 222, 222, 0.4)",
                  borderRadius: "8px",
                  fontWeight: 600,
                  fontSize: "clamp(13px, 1.11vw, 16px)",
                  color: "#FFFFFF",
                  textDecoration: "none",
                }}
              >
                Talk to an SME Advisor
              </RouterLink>
            </div>
          </div>

          {/* Right: hero image */}
          <div
            className="sme-hero-image-wrap"
            style={{
              backgroundColor: "#0E2019",
              borderRadius: "20px",
              overflow: "hidden",
              minHeight: "clamp(280px, 34vw, 460px)",
            }}
          >
            <img
              src={heroImage}
              alt="Business owners managing their operations with Zikora"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "clamp(280px, 34vw, 460px)",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default SmeMain;
